"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var classnames_1 = require("classnames");
require("../../styles/CustomerDetailPage.css");
require("../../styles/PricingPage.css");
var msal_react_1 = require("@azure/msal-react");
var msal_browser_1 = require("@azure/msal-browser");
var authConfig_1 = require("../../authConfig");
var react_1 = require("react");
var PaginationTable_1 = require("../PaginationTable");
var subscription_1 = require("../../api/subscription");
var pricing_1 = require("../../api/pricing");
var PricingNewLicensing_1 = require("./modals/PricingNewLicensing");
var PricingNewServices_1 = require("./modals/PricingNewServices");
var PricingEditLicensing_1 = require("./modals/PricingEditLicensing");
var DeleteButton_1 = require("./modals/DeleteButton");
var PricingEditServices_1 = require("./modals/PricingEditServices");
var DashboardTable_1 = require("./home/DashboardTable");
var PricingPage = function (props) {
    var authRequest = __assign({}, authConfig_1.loginRequest);
    var inProgress = (0, msal_react_1.useMsal)().inProgress;
    var _a = (0, react_1.useState)(false), isLoaded = _a[0], setIsLoaded = _a[1];
    var _b = (0, react_1.useState)(false), licenseDataLoaded = _b[0], setLicenseDataLoaded = _b[1];
    var _c = (0, react_1.useState)(false), serviceDataLoaded = _c[0], setServiceDataLoaded = _c[1];
    var _d = (0, react_1.useState)(false), supportDataLoaded = _d[0], setSupportDataLoaded = _d[1];
    var _e = (0, react_1.useState)(new Array()), licenseData = _e[0], setLicenseData = _e[1];
    var _f = (0, react_1.useState)(new Array()), serviceData = _f[0], setServiceData = _f[1];
    var _g = (0, react_1.useState)({
        supportScaleDefinition: null,
        supportTierDefinition: null
    }), supportData = _g[0], setSupportData = _g[1];
    var _h = React.useState('LicensePricingPage'), activeTab = _h[0], setActiveTab = _h[1]; //useState('CustomerProfile');
    var companyId = parseInt(props.match.params.id, 10) || 0;
    // this for dropdown button for small devices (add buttons)
    var _j = (0, react_1.useState)(false), dropdownOpen = _j[0], setDropdownOpen = _j[1];
    var toggleDropdown = function () { return setDropdownOpen(function (prevState) { return !prevState; }); };
    var licenseListColumns = [
        {
            Header: 'Name',
            accessor: 'name'
        },
        {
            Header: 'Cost Price',
            accessor: 'costPrice',
            Cell: function (row) { return (React.createElement(React.Fragment, null,
                "RM ",
                row.value)); }
        },
        {
            Header: 'Selling Price',
            accessor: 'sellingPrice',
            Cell: function (row) { return (React.createElement(React.Fragment, null,
                "RM ",
                row.value)); }
        },
        {
            Header: 'Monthly/Annually',
            accessor: 'frequency'
        },
        {
            Header: 'Action',
            accessor: 'licenseId',
            Cell: function (row) { return React.createElement("div", { className: "license-action" }, [
                React.createElement(PricingEditLicensing_1.default, { id: row.value, list: licenseData, modalCallback: modalEditLicensingCallback }, null),
                React.createElement(DeleteButton_1.default, { id: row.value, submit: pricing_1.deleteLicense }, null)
            ]); }
        }
    ];
    var supportScaleListColumns = [
        {
            Header: 'Name',
            accessor: 'scaleText'
        },
        {
            Header: 'Num of Users',
            accessor: 'usersText'
        }
    ];
    var supportTierListColumns = [
        {
            Header: 'Support Tier',
            accessor: 'tierText'
        },
        {
            Header: 'Description',
            accessor: 'description'
        }
    ];
    var serviceListColumns = [
        {
            Header: 'Name',
            accessor: 'name'
        },
        {
            Header: 'Cost Price',
            accessor: 'costPrice',
            Cell: function (row) { return (React.createElement(React.Fragment, null,
                "RM ",
                row.value)); }
        },
        {
            Header: 'Selling Price',
            accessor: 'sellingPrice',
            Cell: function (row) { return (React.createElement(React.Fragment, null,
                "RM ",
                row.value)); }
        },
        {
            Header: 'Action',
            accessor: 'serviceId',
            Cell: function (row) { return React.createElement("div", { className: "service-action" }, [
                React.createElement(PricingEditServices_1.default, { id: row.value, list: serviceData, modalCallback: modalEditServiceCallback }, null),
                React.createElement(DeleteButton_1.default, { id: row.value, submit: pricing_1.deleteService }, null)
            ]); }
        }
    ];
    var modalEditLicensingCallback = function (updatedData) {
        setLicenseData(__spreadArray([], licenseData.reduce(function (acc, item) {
            if (updatedData.licenseId == item.licenseId) {
                item.serviceId = updatedData.serviceId;
                item.name = updatedData.name;
                item.costPrice = updatedData.costPrice;
                item.sellingPrice = updatedData.sellingPrice;
                item.description = updatedData.description;
                item.frequency = updatedData.frequency;
            }
            acc.push(item);
            return acc;
        }, new Array()), true));
    };
    var modalEditServiceCallback = function (updatedData) {
        setServiceData(__spreadArray([], serviceData.reduce(function (acc, item) {
            if (updatedData.serviceId == item.serviceId) {
                item.serviceId = updatedData.serviceId;
                item.name = updatedData.name;
                item.costPrice = updatedData.costPrice;
                item.sellingPrice = updatedData.sellingPrice;
                item.description = updatedData.description;
            }
            acc.push(item);
            return acc;
        }, new Array()), true));
    };
    var toggle = function (tab) {
        if (activeTab !== tab)
            setActiveTab(tab);
    };
    var pushToLicenseData = function (item) {
        setLicenseData(__spreadArray(__spreadArray([], licenseData, true), [__assign({}, item)], false));
    };
    var pushToServiceData = function (item) {
        setServiceData(__spreadArray(__spreadArray([], serviceData, true), [__assign({}, item)], false));
    };
    (0, react_1.useEffect)(function () {
        if (licenseDataLoaded == false)
            if (licenseData.length === 0)
                (0, pricing_1.fetchLicenses)().then(function (data) {
                    var mappedData = data.list
                        .map(function (item) {
                        return item;
                    });
                    setLicenseData(mappedData);
                    setIsLoaded(true);
                }).catch(console.error);
        setLicenseDataLoaded(true);
        if (supportDataLoaded == false)
            if (serviceData.length === 0)
                (0, pricing_1.fetchServices)().then(function (data) {
                    var mappedData = data.list
                        .map(function (item) {
                        return item;
                    });
                    setServiceData(mappedData);
                    setIsLoaded(true);
                }).catch(console.error);
        setSupportDataLoaded(true);
        if (supportData && !supportData.supportScaleDefinition && supportData && !supportData.supportTierDefinition)
            (0, subscription_1.fetchSupportDefinition)().then(function (data) {
                var mappedData = data;
                //.map((item: any) => {
                //    return item;
                //});
                setSupportData(mappedData);
                setIsLoaded(true);
            }).catch(console.error);
    }, [inProgress, licenseData, setLicenseData, supportData, setSupportData, serviceData, setServiceData]);
    return (React.createElement(React.Fragment, null,
        React.createElement(msal_react_1.MsalAuthenticationTemplate, { interactionType: msal_browser_1.InteractionType.Redirect, authenticationRequest: authRequest },
            React.createElement("div", { className: "PricingPageHeader" },
                React.createElement("div", null,
                    React.createElement("h5", { className: "card-title" }, "Pricing")),
                React.createElement("div", { className: "PricingPageheaderButton" },
                    React.createElement(PricingNewLicensing_1.default, { modalCallback: pushToLicenseData.bind(_this) }),
                    React.createElement(PricingNewServices_1.default, { modalCallback: pushToServiceData.bind(_this) }))),
            React.createElement("div", { id: "company-profile" },
                React.createElement(reactstrap_1.Nav, { tabs: true },
                    React.createElement(reactstrap_1.NavItem, null,
                        React.createElement(reactstrap_1.NavLink, { className: (0, classnames_1.default)({ active: activeTab === 'LicensePricingPage' }), onClick: function () { toggle('LicensePricingPage'); } }, "Licensing")),
                    React.createElement(reactstrap_1.NavItem, null,
                        React.createElement(reactstrap_1.NavLink, { className: (0, classnames_1.default)({ active: activeTab === 'ServicePricingPage' }), onClick: function () { toggle('ServicePricingPage'); } }, "Services")),
                    React.createElement(reactstrap_1.NavItem, null,
                        React.createElement(reactstrap_1.NavLink, { className: (0, classnames_1.default)({ active: activeTab === 'SupportPricingPage' }), onClick: function () { toggle('SupportPricingPage'); } }, "Support"))),
                React.createElement(reactstrap_1.TabContent, { activeTab: activeTab },
                    React.createElement(reactstrap_1.TabPane, { tabId: "LicensePricingPage" },
                        React.createElement(reactstrap_1.Row, null,
                            React.createElement(reactstrap_1.Col, { sm: "12" },
                                React.createElement("h5", { className: "padding-default card-title" }, "License Pricing"),
                                React.createElement("div", { className: "tableContainer  pricingPageTable" }, licenseData ? React.createElement(PaginationTable_1.PaginationTable, { columns: licenseListColumns, data: licenseData }) : React.createElement(React.Fragment, null, "Loading..."))))),
                    React.createElement(reactstrap_1.TabPane, { tabId: "ServicePricingPage" },
                        React.createElement(reactstrap_1.Row, null,
                            React.createElement(reactstrap_1.Col, { sm: "12" },
                                React.createElement("h5", { className: "padding-default card-title" }, "Service Pricing"),
                                React.createElement("div", { className: "tableContainer pricingPageTable" }, serviceData ? React.createElement(PaginationTable_1.PaginationTable, { columns: serviceListColumns, data: serviceData }) : React.createElement(React.Fragment, null, "Loading..."))))),
                    React.createElement(reactstrap_1.TabPane, { tabId: "SupportPricingPage" },
                        React.createElement(reactstrap_1.Row, null,
                            React.createElement(reactstrap_1.Col, { sm: "12" },
                                React.createElement("h5", { className: "padding-default card-title" }, "Support Scale Definition"),
                                React.createElement("div", { className: "pricingSupportTable" }, supportData && supportData.supportScaleDefinition ? React.createElement(DashboardTable_1.DashboardTable, { columns: supportScaleListColumns, data: supportData.supportScaleDefinition }) : React.createElement(React.Fragment, null, "Loading...")))),
                        React.createElement(reactstrap_1.Row, null,
                            React.createElement(reactstrap_1.Col, { sm: "12" },
                                React.createElement("h5", { className: "padding-default card-title" }, "Support Tier Definition"),
                                React.createElement("div", { className: "pricingSupportTable" }, supportData && supportData.supportTierDefinition ? React.createElement(DashboardTable_1.DashboardTable, { columns: supportTierListColumns, data: supportData.supportTierDefinition }) : React.createElement(React.Fragment, null, "Loading..."))))))))));
};
exports.default = PricingPage;
//# sourceMappingURL=PricingPage.js.map